export const TAG_COLOR = ["#D5499d", "#86D549", "#4957D5", "#D58D49", "#49D5B3"];
